module.exports = __webpack_public_path__ + "img/elipse.86b1398b.svg";